
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '关联理由名称',
value: this.$route.params.RR_NAME
}, {
label: '关联理由简称',
value: this.$route.params.RR_JNAME
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/P_RelatedReasonsDetail.vue